import React from 'react';

interface Props {
    width: number;
    height: number;
    label: string;
    src: string;
}

// Wraps the demo boot flow in a same-origin iframe so it gets its own real
// `window` — ScreenSizeProvider reads window.innerWidth (not container size),
// so only an iframe's own contentWindow can make it switch breakpoints.
export function DeviceFrame({width, height, label, src}: Props) {
    return (
        <div className="DeviceFrame__wrap">
            <div className="DeviceFrame__label">{label}</div>
            <div className="DeviceFrame__bezel" style={{width: width + 16, height: height + 16}}>
                <iframe
                    className="DeviceFrame__iframe"
                    style={{width, height}}
                    src={src}
                    title={label}
                />
            </div>
        </div>
    );
}
